import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
} from "firebase/firestore";
import { db } from "../firebase";

export function normalizeCouponInput(value) {
  return String(value || "")
    .toUpperCase()
    .replace(/\s+/g, "")
    .trim();
}

export function formatDiscountLabel(coupon) {
  if (!coupon) return "";
  const type = String(coupon.discountType || "").toLowerCase();
  const value = Number(coupon.discountValue || 0) || 0;

  if (type === "percent" || type === "percentage") {
    return `${value}% off`;
  }

  if (type === "flat") {
    return `Flat ${formatCurrency(value, coupon.currency || "INR")} off`;
  }

  if (type === "free" || type === "free_trial") {
    return "Free offer";
  }

  return "";
}

export function formatCurrency(paise, currency = "INR") {
  const amount = Number(paise || 0) / 100;
  if (currency === "INR") {
    return `Rs ${amount.toLocaleString("en-IN")}`;
  }
  return `${amount.toLocaleString("en-IN")} ${currency}`;
}

export async function loadMembershipPlans(callback, onError) {
  try {
    const snapshot = await getDocs(query(collection(db, "membershipPlans"), orderBy("createdAt", "desc"), limit(50)));
    callback(snapshot.docs.map((item) => ({ id: item.id, ...item.data() })));
  } catch (error) {
    if (typeof onError === "function") onError(error);
  }
}

export async function loadCoupons(callback, onError) {
  try {
    const snapshot = await getDocs(query(collection(db, "coupons"), orderBy("createdAt", "desc"), limit(100)));
    callback(snapshot.docs.map((item) => ({ id: item.id, ...item.data() })));
  } catch (error) {
    if (typeof onError === "function") onError(error);
  }
}

export async function loadCouponUsage(callback, onError) {
  try {
    const snapshot = await getDocs(query(collection(db, "couponUsage"), orderBy("redeemedAt", "desc"), limit(200)));
    callback(snapshot.docs.map((item) => ({ id: item.id, ...item.data() })));
  } catch (error) {
    if (typeof onError === "function") onError(error);
  }
}

export function toCsv(rows) {
  if (!rows.length) return "";

  const headers = Object.keys(rows[0]);
  const escapeCell = (value) => {
    const text = String(value ?? "");
    if (text.includes(",") || text.includes('"') || text.includes("\n")) {
      return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
  };

  return [
    headers.join(","),
    ...rows.map((row) => headers.map((header) => escapeCell(row[header])).join(",")),
  ].join("\n");
}

export function downloadCsv(filename, csvText) {
  const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
